var map = {
	"./layouts/ext-layout/ext-layout.module": [
		"./src/app/layouts/ext-layout/ext-layout.module.ts",
		"ext-layout.module"
	],
	"./layouts/group-layout/group-layout.module": [
		"./src/app/layouts/group-layout/group-layout.module.ts",
		"group-layout.module"
	],
	"./layouts/owner-layout/owner-layout.module": [
		"./src/app/layouts/owner-layout/owner-layout.module.ts",
		"owner-layout.module"
	],
	"./layouts/super-layout/super-layout.module": [
		"./src/app/layouts/super-layout/super-layout.module.ts",
		"super-layout.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main